import { memo, lazy, Suspense } from "react";
import Header from "./header";
import AuthLayout from "./AuthLayout";
import useAuth from "../hooks/useAuth";

const Footer = lazy(() => import("./footer"));

const GuestLayout = ({ children }) => {
  const { accessType } = useAuth();

  return (
    <>
      {!!accessType ? (
        <AuthLayout>{children}</AuthLayout>
      ) : (
        <>
          <Header />
          {children}
          <Suspense fallback={null}>
            <Footer />
          </Suspense>
        </>
      )}
    </>
  );
};
export default memo(GuestLayout);
